import React from 'react';
import Big from 'big.js';
import moment from 'moment';

import './overdueDetails.scss';

const OverdueDetails = ({ overdue }) => {
  return (
    <td colSpan="6">
      <div className="overdue-content-section">
        <div className="overdue-content-section-left">
          <div className="overdue-content-card">
            <div className="overdue-content-card-group">
              <div className="overdue-content-card-group-item">
                <h3 className="overdue-content-card-group-item-name">
                  <strong>
                    <big>{overdue?.cashBox && overdue.cashBox}</big>
                  </strong>
                </h3>
              </div>
              <div className="overdue-content-card-group-item">
                <p>{overdue?.basePercent && overdue.basePercent.toFixed(2)}% / день</p>
              </div>
            </div>
            <div className="overdue-content-card-group">
              <div className="overdue-content-card-group-item">
                <p>
                  <strong>
                    <big>{overdue?.refundAmount && overdue.refundAmount.toFixed(2)} руб.</big>
                  </strong>
                </p>
              </div>
            </div>
            <div className="overdue-content-card-group">
              <div className="overdue-content-card-group-item">
                <p className="overdue-date">
                  {overdue?.startDate && moment(overdue.startDate).format('DD.MM.YYYY')} -{' '}
                  {overdue?.endDate && moment(overdue.endDate).format('DD.MM.YYYY')}
                </p>
              </div>
              <div className="overdue-content-card-group-item">
                <p>
                  Процент за неустойку{' '}
                  {new Big(overdue.delayPercent).toFixed(2)}%
                </p>
              </div>
            </div>
          </div>
        </div>
        <div className="overdue-content-section-right">
          <table className="table hover overdue-table">
            <thead>
              <tr>
                <th scope="col"></th>
                <th scope="col">
                  <p>Название</p>
                </th>
                <th scope="col">
                  <p>Вес, г.</p>
                </th>
                <th scope="col">
                  <p>Проба</p>
                </th>
                <th scope="col">
                  <p>
                    Оценочная <br />
                    стоимость, руб.
                  </p>
                </th>
                <th scope="col">
                  <p>Количество</p>
                </th>
              </tr>
            </thead>
            <tbody>
              {overdue &&
                overdue?.positions &&
                overdue.positions.length !== 0 &&
                overdue.positions.map((i, ind) => {
                  const purityType = overdue.type === 'PURITY';
                  return (
                    <tr key={i.names && i.names !== 0 && i.names.join() + ind}>
                      <td>
                        <p>{ind + 1}</p>
                      </td>
                      <td>
                        <p>{i.names && i.names !== 0 && i.names.join(' ')}</p>
                      </td>
                      <td>
                        {purityType && i.grossWeight && i.pureWeight? (
                          <>
                            <p>{(+i.grossWeight).toFixed(2)}</p>
                            <p style={{ opacity: 0.6 }}>{(+i.pureWeight).toFixed(2)}</p>
                          </>
                        ) : (
                          <p>-</p>
                        )}
                      </td>
                      <td>
                        <p>{purityType && i.purityType && i.purityName ? `${i.purityType} ${i.purityName}` : '-'}</p>
                      </td>
                      <td>
                        <p>
                          {purityType
                            ? (+i.estimatedValue).toFixed(2)
                            : overdue.totalEstimatedValue.toFixed(2)}
                        </p>
                      </td>
                      <td>
                        <p>{i.quantity}</p>
                      </td>
                    </tr>
                  );
                })}
            </tbody>
            <tfoot>
              <tr>
                <td></td>
                <td colSpan="3">
                  <p>Итого</p>
                </td>
                <td>
                  <p>{overdue.totalEstimatedValue.toFixed(2)}</p>
                </td>
                <td>
                  <p>
                    {overdue.positions.reduce((p, c) => {
                      if (p) return p + c.quantity;
                      else return c.quantity;
                    }, 0)}
                  </p>
                </td>
              </tr>
            </tfoot>
          </table>
        </div>
      </div>
    </td>
  );
};

export default OverdueDetails;
